/* global axios */
import ApiClient from './ApiClient';

class ClaudiaMirrorInboxesAPI extends ApiClient {
  constructor() {
    super('claudia/mirror_inboxes', { apiVersion: 'v1', accountScoped: true });
  }

  getConnectorProjects(projectName) {
    return axios.get(`${this.url}/connector_projects`, {
      params: { project_name: projectName },
    });
  }

  createMirrorInbox({ projectName, connectorProjectName }) {
    return axios.post(this.url, {
      project_name: projectName,
      connector_project_name: connectorProjectName,
    });
  }

  updateProject(inboxId, projectName) {
    return axios.patch(`${this.url}/${inboxId}`, {
      project_name: projectName,
    });
  }
}

export default new ClaudiaMirrorInboxesAPI();
